window.Auth = {
	errorMsg: function ($form, msg) {
		let $el = $form.find('.msg');
		$el.addClass('text-danger mb-3');
		$el.html(msg);
	},
	clearMsg: function ($form) {
		$form.find('.msg').removeClass().addClass('msg').html('');
	}
};

require('./register');
require('./login');